import { Injectable } from '@angular/core';
import { Http, RequestOptions, Response } from '@angular/http';

import * as ApiConfig from '../core/apiconfig';
import * as Model from './index.model';

import { AlarmType, AlarmMaster } from './index.model';

import { HttpHeader } from '../core/httpheader';

@Injectable()
export class AlarmService {

    private apiUrl: string;

    private requestHeader: HttpHeader = new HttpHeader();
    private Http_Header_Request_Options: RequestOptions;

    constructor(private http: Http) {
        this.apiUrl = ApiConfig.API_URL;
    }
    GetAlarmType(jurisID: number): Promise<Array<Model.AlarmType>> {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this.http
            .get(this.apiUrl + "/" + ApiConfig.API_Alarm + "/" + ApiConfig.API_GetAlarmType + "/" + jurisID, this.Http_Header_Request_Options)
            .toPromise()
            .then(response => {
                return response.json() as Array<Model.AlarmType>
            })
            .catch(this.handleError);
    }
    GetAlarmDetails(alarmID: string): Promise<Model.AlarmMaster> {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this.http
            .get(this.apiUrl + "/" + ApiConfig.API_Alarm + "/" + ApiConfig.API_GetAlarmByID + "/" + alarmID, this.Http_Header_Request_Options)
            .toPromise()
            .then(response => {
                return response.json() as Model.AlarmMaster
            })
            .catch(this.handleError);
    }

    GetAlarmByCitizenID(citizenid: string): Promise<Array<Model.AlarmMaster>>{
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this.http
            .get(this.apiUrl + "/" + ApiConfig.API_Alarm + "/" + ApiConfig.API_GetAlarmByCitizenID + "/" + citizenid, this.Http_Header_Request_Options)
            .toPromise()
            .then(response => {
                return response.json() as Array<Model.AlarmMaster>
            })
            .catch(this.handleError);
    }

    RegisterAlarm(alarmObject: AlarmMaster) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();

        return this.http
            .post(this.apiUrl + "/" + ApiConfig.API_Alarm + "/" + ApiConfig.API_Create, alarmObject, this.Http_Header_Request_Options)
            .toPromise()
            .then(response => {
                return response;
            })
            .catch(this.handleError);
    }
    UpdateAlarm(alarmObject: AlarmMaster) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();

        return this.http.put(this.apiUrl + "/" + ApiConfig.API_Alarm + "/" + ApiConfig.API_Update, alarmObject, this.Http_Header_Request_Options)
            .map((res: Response) => res);
    }

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/services/alarm.service.ts